<div class="verify-email-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="verify-email-card">
    <div class="card-content">
      <!-- Mail icon -->
      <div class="mail-icon-wrapper">
        <svg
          class="mail-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="4" width="20" height="16" rx="2"></rect>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
        </svg>
      </div>

      <!-- Text -->
      <div class="card-header">
        <h1 class="card-title">{{ 'register.verify-email-title' | translate }}</h1>
        <p class="card-subtitle">
          {{ 'register.verify-email-sent-to' | translate }}
          <span class="email-highlight">{{ email }}</span>
        </p>
        <p class="card-subtitle">{{ 'register.verify-email-instructions' | translate }}</p>
      </div>

      <!-- Resend button -->
      <button
        class="btn-resend"
        [ngClass]="{
          'btn-resend--sent': resendState === 'sent',
          'btn-resend--cooldown': cooldown > 0 && resendState === 'idle',
        }"
        [disabled]="resendState === 'sending'"
        (click)="handleResend()"
      >
        @if (resendState === 'sending') {
          <svg
            class="btn-loader"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="2" x2="12" y2="6"></line>
            <line x1="12" y1="18" x2="12" y2="22"></line>
            <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
            <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
            <line x1="2" y1="12" x2="6" y2="12"></line>
            <line x1="18" y1="12" x2="22" y2="12"></line>
            <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
            <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
          </svg>
          <span>{{ 'register.verify-email-sending' | translate }}</span>
        } @else if (resendState === 'sent') {
          <svg
            class="btn-check"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <span>{{ 'register.verify-email-resent' | translate }}</span>
        } @else if (resendState === 'idle') {
          @if (cooldown > 0) {
            <span>{{ 'register.verify-email-resend' | translate }} ({{ cooldown }}s)</span>
          } @else {
            <span>{{ 'register.verify-email-resend' | translate }}</span>
          }
        }
      </button>

      <!-- Back link -->
      <a [routerLink]="['/register']" class="back-link">
        <svg
          class="back-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span>{{ 'register.verify-email-back' | translate }}</span>
      </a>
    </div>
  </div>

  <!-- Footer -->
  <p class="footer-text">
    {{ 'register.verify-email-no-email' | translate }}
    <span class="footer-bold">{{ 'register.verify-email-spams' | translate }}</span>
    {{ 'register.verify-email-or' | translate }}
    <button class="footer-resend-link" [disabled]="resendState === 'sending' || cooldown > 0" (click)="handleResend()">
      {{
        cooldown > 0
          ? ('register.verify-email-resend-it' | translate) + ' (' + cooldown + 's)'
          : ('register.verify-email-resend-it' | translate)
      }}
    </button>
  </p>
</div>
